<template>
    <div class="order-list">
      <h1>Whatsapp Messages</h1>
      <ul>
        <li 
          v-for="message in messages" 
          :key="message.id" 
          @click="navigateToOrder(message.order_id)" 
          class="order-item"
        >
          <span><strong>Order Number:</strong> {{ message.shopify_order_number }}</span>
          <span><strong>Unread Messages:</strong> {{ message.newMessagesCount }}</span>
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import { BASE_URL } from "./baseUrl";
  export default {
    name: "MessagesList",
    data() {
      return {
        messages: [
          { id: "1", unreadMessages: 3 },
          { id: "2", unreadMessages: 0 },
          { id: "3", unreadMessages: 5 },
        ],
      };
    },
    mounted() {
        let options = {
            headers: {
                "Access-Control-Allow-Headers":
                    "X-Custom-Header, Access-Control-Request-Headers",
                "x-access-token": localStorage.getItem("token"),
                //"Access-Control-Allow-Headers":"Access-Control-Allow-Origin"
            },
        };
        var url = BASE_URL + `whatsapp/getMessagesCount`;
        axios
            .get(url, options)
            .then((response) => {
                this.messages = response.data
            })
            .catch((error) => {
                console.log(error);
            });

    },
    methods: {
      navigateToOrder(orderId) {
        this.$router.push({ name: "OrderDetails", params: { id: orderId } });
      },
    },
  };
  </script>
  
  <style scoped>
  .order-list {
    font-family: Arial, sans-serif;
    margin: 20px;
  }
  
  h1 {
    color: #333;
  }
  
  ul {
    list-style-type: none;
    padding: 0;
  }
  
  .order-item {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    margin-bottom: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    cursor: pointer;
    background-color: #f9f9f9;
  }
  
  .order-item:hover {
    background-color: #e9ecef;
  }
  
  span {
    margin-right: 10px;
  }
  </style>
  